import { render } from "./SearchReturns.vue?vue&type=template&id=4c0be220&scoped=true"
import script from "./SearchReturns.vue?vue&type=script&lang=js"
export * from "./SearchReturns.vue?vue&type=script&lang=js"

import "./SearchReturns.vue?vue&type=style&index=0&id=4c0be220&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0be220"]])

export default __exports__